// src/slices/termsheetStatusSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: null,
  reason: null,
  date: null,
};

const termsheetStatusSlice = createSlice({
  name: 'termsheetStatus',
  initialState,
  reducers: {
    acceptTerms(state) {
      state.status = 'Accepted';
      state.date = new Date().toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      state.reason = null;
    },
    rejectTerms(state, action) {
      state.status = 'Rejected';
      state.date = new Date().toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      state.reason = action.payload;
    },
    resetStatus(state) {
      state.status = null;
      state.reason = null;
      state.date = null;
    },
  },
});

export const { acceptTerms, rejectTerms, resetStatus } = termsheetStatusSlice.actions;

export default termsheetStatusSlice.reducer;
